export const flattenPatientTests = (patients) =>
  patients.flatMap((patient) =>
    (patient.tests || [])
      .filter((test) => test?.testDay)
      .map((test) => ({
        testDay: new Date(test.testDay),
        testName: test.testName,
        patientId: patient.id,
      }))
      .filter((test) => !Number.isNaN(test.testDay.getTime()))
  );

const MONTH_LABELS = [
  "Ene",
  "Feb",
  "Mar",
  "Abr",
  "May",
  "Jun",
  "Jul",
  "Ago",
  "Sep",
  "Oct",
  "Nov",
  "Dic",
];

export const getISOWeek = (date) => {
  const target = new Date(date);
  target.setHours(0, 0, 0, 0);
  target.setDate(target.getDate() + 4 - (target.getDay() || 7));
  const yearStart = new Date(target.getFullYear(), 0, 1);
  return Math.ceil(((target - yearStart) / 86400000 + 1) / 7);
};

export const buildMonthlyProductivity = (
  patients,
  year = new Date().getFullYear()
) => {
  const tests = flattenPatientTests(patients).filter(
    (test) => test.testDay.getFullYear() === year
  );

  const counts = Array.from({ length: 12 }, (_, index) => ({
    key: `${year}-${String(index + 1).padStart(2, "0")}`,
    label: MONTH_LABELS[index],
    count: 0,
  }));

  for (const test of tests) {
    const monthIndex = test.testDay.getMonth();
    counts[monthIndex].count += 1;
  }

  return {
    year,
    total: tests.length,
    points: counts,
  };
};

export const buildWeeklyProductivity = (
  patients,
  year = new Date().getFullYear()
) => {
  const tests = flattenPatientTests(patients).filter(
    (test) => test.testDay.getFullYear() === year
  );

  const weekCounts = new Map();
  for (const test of tests) {
    const week = getISOWeek(test.testDay);
    const key = `${year}-W${String(week).padStart(2, "0")}`;
    weekCounts.set(key, (weekCounts.get(key) || 0) + 1);
  }

  const currentWeek =
    year === new Date().getFullYear()
      ? getISOWeek(new Date())
      : getISOWeek(new Date(year, 11, 28));

  const points = [];
  for (let week = 1; week <= currentWeek; week += 1) {
    const key = `${year}-W${String(week).padStart(2, "0")}`;
    points.push({
      key,
      label: `S${week}`,
      count: weekCounts.get(key) || 0,
    });
  }

  return {
    year,
    total: tests.length,
    points,
  };
};

export const buildProductivityTrend = (patients) => ({
  monthly: buildMonthlyProductivity(patients),
  weekly: buildWeeklyProductivity(patients),
});
